import { render, staticRenderFns } from "./FormularioPlanesHoras.vue?vue&type=template&id=65612aa6"
import script from "./FormularioPlanesHoras.vue?vue&type=script&lang=js"
export * from "./FormularioPlanesHoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports